module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/info-eff1da79.png";